<template>
    <div class="max-w-7xl mx-auto py-20">
        <div class="mx-20 2xl:mx-0">
            <div class="w-full h-full bg-white mt-5 flex">
                <div class="h-full w-1/2 mt-5 flex flex-col">
                    <h1 class="text-3xl font-semibold mb-4 lg:text-8xl">
                        {{ proposal.places[0].name }}, {{ proposal.places[0].parent.name }}
                    </h1>
                    <EditableProposalText v-for="destination in destinations" :text="destination.lead" />
                    <EditableProposalText v-for="destination in destinations" :text="destination.text" />
                </div>
                <div  class="relative py-4 ml-6 h-96 w-1/2">
                    <GMapMap
                        v-for="destination in destinations"
                        :center="destination.center"
                        :zoom="7.8"
                        map-type-id="terrain"
                        style="position: absolute; width: 100%; height: 100%; border-radius: 10px"
                    >
                        <GMapMarker
                            :position="destination.center"
                        />
                    </GMapMap>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";
import EditableProposalText from "@/ComponentsDeprecated/Proposal/EditableProposalText";

const props = defineProps(
    {
        proposal: {
            type: Object,
            required: true
        }
    }
)

const destinations = [
    {
        lead: 'Nice ligger langs den flotte og populære franke rivieraen',
        text: 'Ta en spasertur på strandpromenaden, nyt lyden av bølgene mot stranden og duften av deilig mat som serveres a la Provencale. I Nice lever du det gode liv.',
        center: {
            lat: props.proposal.places[0].location.coordinates[0],
            lng: props.proposal.places[0].location.coordinates[1]
        },
        id: 1,
        isActive: true,
    },
];

const editable = ref(false)

function makeEditable() {
    editable.value = true
}

function notEditable() {
    editable.value = false
}
</script>
